/* American Threads Co - turn long or named variant options into dropdowns,
   and keep the product gallery in step with what the shopper picks.

   PART 1 - DROPDOWNS
   An option becomes a dropdown when it has MIN_VALUES or more values (the
   Custom Baseball Jersey has 19 sizes) OR when its name is in FORCE_OPTIONS
   (Color and Skin Tone on the ugly sweaters: six values each, but six long
   pills still swamp the page).

   The theme's own markup is never touched: the real fieldset is hidden with a
   CSS :has() rule and the dropdown clicks the hidden radios. The dropdown is
   placed inside the add-to-cart form, above the personalisation block, which
   is the one spot that survives Horizon's re-render.

   PART 2 - GALLERY SYNC
   Picking a colour should show that colour; touching Skin Tone should show the
   skin tone guide. A variant carries only one featured image, so Shopify alone
   cannot do both.

   Slides are matched on the IMAGE ALT TEXT, not the file name, so renaming a
   file in Content > Files cannot break it. The convention is:
     - every colourway image's alt starts with the exact option value
       ("Navy Snowflake ugly Christmas sweater, front view")
     - the skin tone guide's alt contains "skin tone"
*/
(function () {
  var MIN_VALUES = 11;
  var SKIP_OPTIONS = ['design'];
  /* 2026-10-28: Color left out on purpose - Andi wants Color (like Size) as one
     horizontal scrolling row on every product, never a dropdown. */
  var FORCE_OPTIONS = ['skin tone', 'skintone'];
  var SKIN_HINT = 'skin tone';
  var hidden = {};

  function baseStyle() {
    if (document.getElementById('atc-vsel-style')) return;
    var s = document.createElement('style');
    s.id = 'atc-vsel-style';
    s.textContent = [
      '.atc-vsel-wrap{margin:0 0 18px;}',
      '.atc-vsel-wrap > span{display:block;font-size:13px;letter-spacing:.02em;margin:0 0 6px;}',
      '.atc-vsel{display:block;width:100%;box-sizing:border-box;',
      'padding:12px 14px;border-radius:8px;border:1px solid rgba(255,255,255,.3);',
      'background:transparent;color:inherit;font:inherit;font-size:15px;',
      'line-height:1.2;cursor:pointer;}',
      '.atc-vsel:focus{outline:none;border-color:currentColor;}',
      '.atc-vsel option{color:#000;background:#fff;}',
      '@media (max-width:749px){.atc-vsel{font-size:16px;}}'
    ].join('');
    document.head.appendChild(s);
  }

  function hideFieldset(optionName) {
    if (hidden[optionName]) return;
    hidden[optionName] = true;
    var s = document.createElement('style');
    s.setAttribute('data-atc-vsel-hide', optionName);
    s.textContent = 'fieldset.variant-option:has(input[data-option-name="' +
      optionName.replace(/"/g, '') + '"]){position:absolute!important;' +
      'width:1px!important;height:1px!important;overflow:hidden!important;' +
      'clip:rect(0 0 0 0)!important;margin:0!important;padding:0!important;' +
      'border:0!important;opacity:0!important;pointer-events:none!important;}';
    document.head.appendChild(s);
  }

  function mainForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.closest('.card, .product-card, product-card, .resource-list__item, .quick-add')) continue;
      return f;
    }
    return null;
  }

  function radios(optionName) {
    return [].slice.call(
      document.querySelectorAll('variant-picker input[type="radio"][data-option-name="' + optionName.replace(/"/g, '') + '"]')
    );
  }

  function available(r) { return r.getAttribute('aria-disabled') !== 'true'; }

  function signature(list) {
    return list.map(function (r) {
      return r.value + (r.checked ? '*' : '') + (available(r) ? '' : 'x');
    }).join('|');
  }

  /* ---------------- gallery sync ---------------- */

  function productSlideshow() {
    var all = document.querySelectorAll('slideshow-component');
    for (var i = 0; i < all.length; i++) {
      if (all[i].closest('.card, .product-card, product-card, .resource-list__item, .quick-add')) continue;
      return all[i];
    }
    return null;
  }

  function currentIndex(sc) {
    var slides = sc.querySelectorAll('slideshow-slide');
    if (!slides.length) return -1;
    var track = sc.querySelector('slideshow-slides');
    var w = slides[0].getBoundingClientRect().width || 1;
    return track ? Math.round(track.scrollLeft / w) : 0;
  }

  function altAt(sc, i) {
    var slides = sc.querySelectorAll('slideshow-slide');
    if (!slides[i]) return '';
    var img = slides[i].querySelector('img');
    return img && img.alt ? img.alt.toLowerCase() : '';
  }

  /* A needle is one string or a list of strings that must ALL be in the alt.
     2026-10-28: products with Design + Color (SP030) have one slide per design
     and colour, and matching on the colour alone always landed on the first
     design's slide, so the checked Design value is now part of the needle. */
  function altHas(alt, needle) {
    var list = typeof needle === 'string' ? [needle] : needle;
    for (var i = 0; i < list.length; i++) { if (alt.indexOf(list[i]) === -1) return false; }
    return true;
  }

  function findAlt(sc, needle) {
    var slides = sc.querySelectorAll('slideshow-slide');
    for (var i = 0; i < slides.length; i++) {
      if (altHas(altAt(sc, i), needle)) return i;
    }
    return -1;
  }

  /* Horizon REPLACES the whole <slideshow-component> after a variant change,
     so a one-shot timer is useless - the jump gets thrown away with the old
     element. Instead hold the target and keep nudging until the deadline. */
  var chase = null;

  function stopChase() { if (chase) { clearInterval(chase); chase = null; } }

  function chaseAlt(needle, ms) {
    stopChase();
    var deadline = Date.now() + (ms || 4000);
    var tick = function () {
      if (Date.now() > deadline) { stopChase(); return; }
      var sc = productSlideshow();
      if (!sc) return;
      var cur = currentIndex(sc);
      /* Already on target: do nothing, but KEEP chasing. Horizon re-renders
         the media about 900ms after a variant change and snaps back to the
         first slide, so stopping at the first match loses the jump. */
      if (cur >= 0 && altHas(altAt(sc, cur), needle)) return;
      var idx = findAlt(sc, needle);
      if (idx < 0 && typeof needle !== 'string') idx = findAlt(sc, needle[0]);
      if (idx < 0) return;
      var btns = sc.querySelectorAll('slideshow-controls button');
      if (btns && btns[idx]) { btns[idx].click(); return; }
      try { if (typeof sc.select === 'function') sc.select(idx); } catch (e) {}
    };
    chase = setInterval(tick, 220);
    setTimeout(tick, 60);
  }
  /* PART 3 (combo) shows shirt 2's design in the colour picked for it */
  window.atcChaseAlt = chaseAlt;

  /* If the shopper takes the gallery over, get out of the way at once. */
  document.addEventListener('pointerdown', function (e) {
    if (e.target && e.target.closest && e.target.closest('slideshow-component')) stopChase();
  }, true);

  function syncGallery(optionName, value) {
    var n = String(optionName || '').toLowerCase();
    var needle = null;

    if (n.indexOf('skin') !== -1) {
      needle = SKIN_HINT;
    } else if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1) {
      needle = String(value || '').toLowerCase();
      var d = document.querySelector('variant-picker input[type="radio"][data-option-name="Design"]:checked');
      /* couple combo: the Color row is shirt 1's colour, so show shirt 1
         (the first design) in it, not the two-shirt combo photo (Andi) */
      var dv = d ? d.value : '';
      if (d && /combo/i.test(dv)) {
        var first = [].filter.call(document.querySelectorAll('variant-picker input[type="radio"][data-option-name="Design"]'),
          function (r) { return !/combo/i.test(r.value); })[0];
        dv = first ? first.value : dv;
      }
      if (d) needle = [needle, dv.toLowerCase()];
    } else if (n === 'design') {
      /* a new design shows that design in the colour already picked */
      var c = document.querySelector('variant-picker input[type="radio"][data-option-name="Color"]:checked');
      if (c) needle = [c.value.toLowerCase(), String(value || '').toLowerCase()];
    }
    if (!needle) return;
    chaseAlt(needle, 4000);
  }

  /* Buttons that were never converted still need to drive the gallery. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio') return;
    if (!t.closest || !t.closest('variant-picker')) return;
    syncGallery(t.getAttribute('data-option-name'), t.value);
  }, true);

  /* ---------------- dropdown conversion ---------------- */

  function convert(fs) {
    var first = fs.querySelector('input[type="radio"]');
    if (!first) return;

    var optionName = first.getAttribute('data-option-name') || '';
    if (!optionName) return;

    var lower = optionName.toLowerCase();
    if (SKIP_OPTIONS.indexOf(lower) !== -1) return;

    var list = radios(optionName);
    /* Couple combo products: the Size option also holds pair values ("S + M").
       PART 3 below draws its own rows for it, so leave it alone here. */
    for (var k = 0; k < list.length; k++) { if (list[k].value.indexOf(' + ') !== -1) return; }
    var forced = FORCE_OPTIONS.indexOf(lower) !== -1;
    if (!forced && list.length < MIN_VALUES) return;
    if (list.length < 2) return;

    var form = mainForm();
    if (!form) return;

    baseStyle();
    hideFieldset(optionName);

    var wrap = form.querySelector('[data-atc-vsel="' + optionName + '"]');
    var sig = signature(list);

    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'atc-vsel-wrap';
      wrap.setAttribute('data-atc-vsel', optionName);

      var lab = document.createElement('span');
      var legend = fs.querySelector('legend');
      lab.textContent = legend ? legend.textContent.trim() : optionName;
      wrap.appendChild(lab);

      var sel = document.createElement('select');
      sel.className = 'atc-vsel';
      sel.setAttribute('aria-label', lab.textContent);
      wrap.appendChild(sel);

      sel.addEventListener('change', function () {
        var want = this.value;
        if (!want) return;
        var all = radios(optionName);
        for (var i = 0; i < all.length; i++) {
          if (all[i].value === want && !all[i].checked) { all[i].click(); break; }
        }
        syncGallery(optionName, want);
      });

      var anchor = form.querySelector('[data-atc-ct]');
      if (!anchor) {
        var submit = form.querySelector('[type="submit"]');
        anchor = submit ? (submit.closest('.product-form-buttons, .product-form__buttons, buy-buttons-component') || submit) : null;
      }
      if (anchor && anchor.parentNode && form.contains(anchor)) {
        anchor.parentNode.insertBefore(wrap, anchor);
      } else {
        form.appendChild(wrap);
      }
    }

    if (wrap.getAttribute('data-atc-sig') === sig) return;

    var select = wrap.querySelector('select');
    var html = '';
    var checked = '';

    list.forEach(function (r) {
      if (!available(r)) return;
      if (r.checked) checked = r.value;
      html += '<option value=' + JSON.stringify(r.value) + '>' +
              r.value.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</option>';
    });

    if (!checked) {
      html = '<option value="" disabled selected>Choose a ' +
             (wrap.firstChild.textContent || 'size').toLowerCase() + '</option>' + html;
    }

    select.innerHTML = html;
    select.value = checked || '';
    wrap.setAttribute('data-atc-sig', sig);
  }

  function scan() {
    var sets = document.querySelectorAll('variant-picker fieldset.variant-option');
    for (var i = 0; i < sets.length; i++) {
      try { convert(sets[i]); } catch (e) {}
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; scan(); }, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['aria-disabled', 'checked']
  });
})();
/* PART 3 - COUPLE COMBO (2026-10-28, SP030; v3 two colours)
   A combo product sells two shirts as one variant. The Design option gets a
   value with "combo" in it, the Color option is shirt 1's colour, and the Size
   option gets PAIR values "<shirt 1> + <shirt 2>". A pair side is either an
   exact size ("M", as SP030 uses) or a price tier ("S-XL" = every size from S
   to XL, which all cost the same), for a product that would otherwise need
   too many variants. Freshly created variants can read Sold out on the shop
   for 20 minutes or so while Shopify catches up; that is not this script.

   Andi wants each shirt's colour and size picked on its own, and 8 x 8 colours
   x 36 pairs would be 2,304 variants, past Shopify's cap. So shirt 2's colour
   (and both sizes, for tier products) travel as line item properties ("Shirt 1", "Shirt 2"),
   which show in the cart, checkout and order for printing.

   When the combo is picked the theme Size row is hidden and three rows are
   drawn after it: Size for Shirt 1, Color for Shirt 2, Size for Shirt 2, each
   named after the design that shirt carries. Picking a size clicks the hidden
   pair radio for its tier, so Horizon still does price, image and cart.

   The rows sit INSIDE variant-picker for the theme's button look, but in a
   <div>, not a <fieldset>: Horizon reads every "fieldset input:checked" as an
   option value and throws on ours. Their change events stop before they reach
   variant-picker. Horizon morphs the picker after every change and drops our
   rows; the observer puts them straight back from the saved state. */
(function () {
  var SEP = ' + ';
  var css = false;
  /* what the shopper picked; survives Horizon's re-renders */
  var st = { s1: null, s2: null, c2: null, c2touched: false, last: 0 };

  function q(sel) { return [].slice.call(document.querySelectorAll(sel)); }
  function esc(v) { return String(v).replace(/"/g, '\\"'); }
  function radios(opt) { return q('variant-picker input[type="radio"][data-option-name="' + esc(opt) + '"]'); }
  function checkedVal(opt) {
    var r = radios(opt).filter(function (x) { return x.checked; })[0];
    return r ? r.value : null;
  }

  function pairOption() {
    var all = q('variant-picker input[type="radio"][data-option-name]');
    for (var i = 0; i < all.length; i++) {
      if (all[i].value.indexOf(SEP) !== -1) return all[i].getAttribute('data-option-name');
    }
    return null;
  }

  function comboRadio() {
    var all = q('variant-picker input[type="radio"][data-option-name]');
    for (var i = 0; i < all.length; i++) {
      if (/combo/i.test(all[i].value)) return all[i];
    }
    return null;
  }

  function colorOption() {
    var all = q('variant-picker input[type="radio"][data-option-name]');
    for (var i = 0; i < all.length; i++) {
      var n = all[i].getAttribute('data-option-name');
      if (/colou?r/i.test(n)) return n;
    }
    return null;
  }

  function fieldsetOf(opt) {
    var r = radios(opt)[0];
    return r ? r.closest('fieldset') : null;
  }

  /* the single sizes, in the theme's order (S, M, L ... 3XL) */
  function singleSizes(sizeOpt) {
    return radios(sizeOpt).map(function (r) { return r.value; })
      .filter(function (v) { return v.indexOf(SEP) === -1; });
  }

  /* which pair side a size falls in: itself, or a tier "A-B" spanning it */
  function sideFor(size, tokens, order) {
    if (tokens.indexOf(size) !== -1) return size;
    var at = order.indexOf(size);
    for (var i = 0; i < tokens.length; i++) {
      var m = /^(.+?)-(.+)$/.exec(tokens[i]);
      if (!m) continue;
      var a = order.indexOf(m[1]), b = order.indexOf(m[2]);
      if (a !== -1 && b !== -1 && at >= a && at <= b) return tokens[i];
    }
    return null;
  }

  function style(sizeOpt) {
    if (css) return;
    css = true;
    var n = esc(sizeOpt);
    var s = document.createElement('style');
    s.id = 'atc-combo-style';
    s.textContent = [
      /* pair values never show in the theme row */
      'variant-picker label:has(> input[data-option-name="' + n + '"][value*=" + "]){display:none!important;}',
      /* in combo mode the whole theme Size row gives way to ours */
      'html.atc-combo-on variant-picker fieldset.variant-option:has(input[data-option-name="' + n + '"]){display:none!important;}',
      '.atc-combo{display:block;white-space:nowrap;overflow-x:auto;min-width:0;max-width:100%;',
      'padding-bottom:6px;margin:0 0 16px;scrollbar-width:none;overscroll-behavior-x:contain;}',
      '.atc-combo::-webkit-scrollbar{display:none;}',
      '.atc-combo__lab{display:block;position:sticky;left:0;white-space:normal;margin:0 0 10px;',
      'font-size:16px;font-weight:700;line-height:1.3;text-transform:none;letter-spacing:normal;}',
      '.atc-combo__lab span{font-weight:400;}',
      '.atc-combo > label{display:inline-flex;vertical-align:middle;margin-right:11px;}',
      '.atc-combo > label:last-of-type{margin-right:0;}',
      '.atc-combo-save{margin:6px 0 10px;color:#A3161C;font-size:15px;font-weight:700;line-height:1.35;}'
    ].join('');
    document.head.appendChild(s);
  }

  function designsOf(combo) {
    return radios(combo.getAttribute('data-option-name'))
      .map(function (r) { return r.value; })
      .filter(function (v) { return !/combo/i.test(v); });
  }

  function makeLabel(text, value) {
    var lab = document.createElement('span');
    lab.className = 'atc-combo__lab';
    lab.appendChild(document.createTextNode(text + (value ? ': ' : '')));
    if (value) {
      var v = document.createElement('span');
      v.textContent = value;
      lab.appendChild(v);
    }
    return lab;
  }

  function sizeRow(k, sizes, cur, label) {
    var row = document.createElement('div');
    row.className = 'variant-option atc-combo';
    row.setAttribute('data-atc-row', 's' + (k + 1));
    row.setAttribute('role', 'radiogroup');
    row.setAttribute('aria-label', label);
    row.appendChild(makeLabel(label, cur));
    sizes.forEach(function (sz) {
      var l = document.createElement('label');
      l.className = 'variant-option__button-label';
      var inp = document.createElement('input');
      inp.type = 'radio';
      inp.name = 'atc-combo-s' + (k + 1);
      inp.value = sz;
      inp.setAttribute('data-atc-combo', 's' + (k + 1));
      if (cur === sz) inp.checked = true;
      l.appendChild(inp);
      var pill = document.createElement('span');
      pill.className = 'variant-option__button-label__pill';
      l.appendChild(pill);
      var t = document.createElement('span');
      t.className = 'variant-option__button-label__text';
      t.textContent = sz;
      l.appendChild(t);
      row.appendChild(l);
    });
    return row;
  }

  /* shirt 2's colours: copies of the theme's own colour swatches, cut loose
     from the variant picker (new name, no option data) */
  function colorRow(colorFs, cur, label) {
    var row = document.createElement('div');
    row.className = 'variant-option variant-option--swatches atc-combo';
    row.setAttribute('data-atc-row', 'c2');
    row.setAttribute('role', 'radiogroup');
    row.setAttribute('aria-label', label);
    row.appendChild(makeLabel(label, cur));
    [].slice.call(colorFs.querySelectorAll('label')).forEach(function (src) {
      var srcIn = src.querySelector('input[type="radio"]');
      if (!srcIn) return;
      var l = src.cloneNode(true);
      var inp = l.querySelector('input[type="radio"]');
      [].slice.call(inp.attributes).map(function (a) { return a.name; }).forEach(function (n) {
        if (n !== 'type' && n !== 'value' && n !== 'class') inp.removeAttribute(n);
      });
      inp.name = 'atc-combo-c2';
      inp.value = srcIn.value;
      inp.setAttribute('aria-label', srcIn.value);
      inp.setAttribute('data-atc-combo', 'c2');
      inp.checked = srcIn.value === cur;
      [].slice.call(l.querySelectorAll('.strikethrough, [class*="strikethrough"]')).forEach(function (e) { e.remove(); });
      row.appendChild(l);
    });
    return row;
  }

  function hiddenPair(sizeOpt, want) {
    return radios(sizeOpt).filter(function (r) { return r.value === want; })[0] || null;
  }

  /* point the hidden Size option at the tier pair for the sizes picked */
  function pushPair(sizeOpt) {
    var pairs = radios(sizeOpt).map(function (r) { return r.value; })
      .filter(function (v) { return v.indexOf(SEP) !== -1; });
    var tokens = [[], []];
    pairs.forEach(function (v) {
      var p = v.split(SEP);
      for (var k = 0; k < 2; k++) if (tokens[k].indexOf(p[k]) === -1) tokens[k].push(p[k]);
    });
    var order = singleSizes(sizeOpt);
    var a = sideFor(st.s1, tokens[0], order), b = sideFor(st.s2, tokens[1], order);
    if (!a || !b) return;
    var r = hiddenPair(sizeOpt, a + SEP + b);
    if (r && !r.checked) r.click();
  }

  function build(sizeOpt, combo, colorOpt) {
    var picker = combo.closest('variant-picker');
    var sizeFs = fieldsetOf(sizeOpt);
    var colorFs = colorOpt ? fieldsetOf(colorOpt) : null;
    if (!picker || !sizeFs) return;
    var sizes = singleSizes(sizeOpt);
    if (!sizes.length) return;
    var designs = designsOf(combo);
    var c1 = colorOpt ? checkedVal(colorOpt) : null;

    var lab1 = 'Size for Shirt 1' + (designs[0] ? ' (' + designs[0] + ')' : '');
    var labC = 'Color for Shirt 2' + (designs[1] ? ' (' + designs[1] + ')' : '');
    var lab2 = 'Size for Shirt 2' + (designs[1] ? ' (' + designs[1] + ')' : '');

    /* retitle the theme Color row for shirt 1. atc-row-label.js paints row
       names from --atc-row-label (iOS will not paint a scrolling legend), so
       override that variable while the combo is on. */
    if (colorFs) {
      colorFs.classList.add('atc-combo-c1');
      var txt1 = 'Color for Shirt 1' + (designs[0] ? ' (' + designs[0] + ')' : '') + (c1 ? ': ' + c1 : '');
      var ls = document.getElementById('atc-combo-c1-style');
      if (!ls) {
        ls = document.createElement('style');
        ls.id = 'atc-combo-c1-style';
        document.head.appendChild(ls);
      }
      var rule = 'html.atc-combo-on variant-picker fieldset.atc-combo-c1{--atc-row-label:' + JSON.stringify(txt1) + ';}';
      if (ls.textContent !== rule) ls.textContent = rule;
    }

    var sig = [st.s1, st.c2, st.s2, sizes.join(','), c1].join('|');
    var old = picker.querySelectorAll('.atc-combo');
    if (old.length === 3 && old[0].getAttribute('data-sig') === sig &&
        old[0].previousElementSibling === sizeFs) return;
    for (var o = 0; o < old.length; o++) old[o].remove();

    var rows = [sizeRow(0, sizes, st.s1, lab1)];
    if (colorFs) rows.push(colorRow(colorFs, st.c2, labC));
    rows.push(sizeRow(1, sizes, st.s2, lab2));

    var anchor = sizeFs;
    rows.forEach(function (row) {
      row.setAttribute('data-sig', sig);
      row.addEventListener('change', function (e) {
        e.stopPropagation();
        var t = e.target;
        var which = t && t.getAttribute('data-atc-combo');
        if (!which) return;
        if (which === 's1') st.s1 = t.value;
        if (which === 's2') st.s2 = t.value;
        if (which === 'c2') {
          st.c2 = t.value;
          st.c2touched = true;
          st.last = 2;
        }
        pushPair(sizeOpt);
        /* the gallery shows the shirt whose colour was picked last, in that
           colour, and holds it through the re-render a size change sets off */
        var c1now = colorOpt ? checkedVal(colorOpt) : null;
        var look = st.last === 2 ? [st.c2, designs[1]] : st.last === 1 ? [c1now, designs[0]] : null;
        if (window.atcChaseAlt && look && look[0] && look[1]) {
          window.atcChaseAlt([look[0].toLowerCase(), look[1].toLowerCase()], 4000);
        }
        schedule();
      });
      anchor.parentNode.insertBefore(row, anchor.nextSibling);
      anchor = row;
    });
  }

  /* The real picks ride along with the cart line. Inputs live inside the
     add-to-cart form so FormData picks them up; outside the combo they are
     removed so a single shirt never carries them. */
  function productForm() {
    var forms = q('form[action*="/cart/add"]').filter(function (f) {
      return !f.closest('.card, .product-card, product-card, .resource-list__item, .quick-add, quick-add-component');
    });
    return forms[0] || null;
  }

  function props(on, combo, colorOpt) {
    var form = productForm();
    var olds = q('input[data-atc-prop]');
    if (!on || !form) { olds.forEach(function (e) { e.remove(); }); return; }
    var designs = designsOf(combo);
    var c1 = colorOpt ? checkedVal(colorOpt) : null;
    var vals = {
      'Shirt 1': [designs[0], c1, st.s1].filter(Boolean).join(' · '),
      'Shirt 2': [designs[1], st.c2 || c1, st.s2].filter(Boolean).join(' · ')
    };
    Object.keys(vals).forEach(function (k) {
      var name = 'properties[' + k + ']';
      var el = form.querySelector('input[data-atc-prop="' + k + '"]');
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = name;
        el.setAttribute('data-atc-prop', k);
        form.appendChild(el);
      }
      if (el.value !== vals[k]) el.value = vals[k];
    });
    olds.forEach(function (e) { if (!form.contains(e)) e.remove(); });
  }

  /* Switching between a single shirt and the combo: entering, both shirts
     take the single size; leaving, the single size is shirt 1's. One nudge
     per state, so a click that does not take cannot loop. */
  var nudged = '';
  function carry(sizeOpt, on) {
    var cur = checkedVal(sizeOpt);
    if (!cur) return;
    var isPair = cur.indexOf(SEP) !== -1;
    if (isPair === on) return;
    var state = (on ? 'on:' : 'off:') + cur;
    if (nudged === state) return;
    nudged = state;
    if (on) {
      st.s1 = st.s2 = cur;
      pushPair(sizeOpt);
    } else {
      var want = st.s1 || cur.split(SEP)[0];
      var r = hiddenPair(sizeOpt, want);
      if (!r) r = radios(sizeOpt).filter(function (x) { return x.value.indexOf(SEP) === -1; })[0];
      if (r) r.click();
    }
  }

  /* The saving, in words, right under the price: the combo against the two
     single shirts at the colours and sizes picked, read from the product's own
     variant list so it is exact to the cent. A combo whose name has no
     "Save N%" gets no line, and neither does one with no saving. */
  var prod = null, asked = false;
  function loadProduct(picker) {
    if (asked) return;
    asked = true;
    var url = (picker && picker.dataset.productUrl || location.pathname).split('?')[0] + '.js';
    fetch(url).then(function (r) { return r.json(); })
      .then(function (j) { prod = j; schedule(); })
      .catch(function () {});
  }

  function note(combo, on, sizeOpt, colorOpt) {
    var el = document.querySelector('.atc-combo-save');
    var m = combo && /save\s*(\d+)\s*%/i.exec(combo.value);
    if (!on || !m) { if (el) el.remove(); return; }
    var picker = combo.closest('variant-picker');
    if (!prod) { loadProduct(picker); return; }

    var names = prod.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
    var di = names.indexOf(combo.getAttribute('data-option-name'));
    var si = names.indexOf(sizeOpt), ci = colorOpt ? names.indexOf(colorOpt) : -1;
    var pairVal = checkedVal(sizeOpt);
    if (di < 0 || si < 0 || !pairVal || pairVal.indexOf(SEP) === -1) { if (el) el.remove(); return; }
    var c1 = colorOpt ? checkedVal(colorOpt) : null;

    function find(design, color, size) {
      for (var i = 0; i < prod.variants.length; i++) {
        var o = prod.variants[i].options;
        if (o[di] === design && o[si] === size && (ci < 0 || o[ci] === color)) return prod.variants[i];
      }
      return null;
    }
    var designs = designsOf(combo);
    var mine = find(combo.value, c1, pairVal);
    /* products.js stops at 250 variants, and SP030's later combo colours sit
       past that, so fall back to the variant the picker itself embeds */
    if (!mine && picker) {
      var js = picker.querySelector('script[type="application/json"]');
      try {
        var v = js ? JSON.parse(js.textContent) : null;
        if (v && v.options && v.options.indexOf(combo.value) !== -1 && v.options.indexOf(pairVal) !== -1 &&
            (!c1 || v.options.indexOf(c1) !== -1)) mine = v;
      } catch (e) {}
    }
    var p1 = find(designs[0], c1, st.s1);
    var p2 = find(designs[1], st.c2 || c1, st.s2);
    if (!mine || !p1 || !p2) { if (el) el.remove(); return; }
    var save = p1.price + p2.price - mine.price;
    if (save <= 0) { if (el) el.remove(); return; }

    var txt = 'You save $' + (save / 100).toFixed(2) + ' vs. 2 single shirts (' + m[1] + '% off)';
    var price = null;
    q('product-price').forEach(function (p) {
      if (!price && !p.closest('.card, .product-card, product-card, .resource-list__item, .quick-add')) price = p;
    });
    if (!price || !price.parentNode) return;
    if (!el) {
      el = document.createElement('div');
      el.className = 'atc-combo-save';
    }
    if (el.textContent !== txt) el.textContent = txt;
    if (price.nextSibling !== el) price.parentNode.insertBefore(el, price.nextSibling);
  }

  function run() {
    var sizeOpt = pairOption();
    if (!sizeOpt) return;
    style(sizeOpt);
    var combo = comboRadio();
    var colorOpt = colorOption();
    var on = !!(combo && combo.checked);
    document.documentElement.classList.toggle('atc-combo-on', on);
    carry(sizeOpt, on);
    if (on) {
      var c1 = colorOpt ? checkedVal(colorOpt) : null;
      /* shirt 2 follows shirt 1's colour until the shopper picks one */
      if (!st.c2touched || !st.c2) st.c2 = c1;
      if (!st.s1 || !st.s2) {
        var p = String(checkedVal(sizeOpt) || '').split(SEP);
        var order = singleSizes(sizeOpt);
        st.s1 = st.s1 || (order.indexOf(p[0]) !== -1 ? p[0] : order[0]);
        st.s2 = st.s2 || (order.indexOf(p[1]) !== -1 ? p[1] : order[0]);
      }
    }
    props(on, combo, colorOpt);
    note(combo, on, sizeOpt, colorOpt);
    if (!on) {
      q('.atc-combo').forEach(function (e) { e.remove(); });
      q('.atc-combo-c1').forEach(function (e) { e.classList.remove('atc-combo-c1'); });
      return;
    }
    build(sizeOpt, combo, colorOpt);
  }

  /* shirt 1's colour is the theme's own Color row */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.type === 'radio' && t.closest && t.closest('variant-picker') &&
        /colou?r/i.test(t.getAttribute('data-option-name') || '')) st.last = 1;
  }, true);

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    Promise.resolve().then(function () { queued = false; try { run(); } catch (e) {} });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'aria-disabled']
  });
})();
